import type { ReactNode } from "react";
import { useAuth } from "./LoginGate";
import { canWrite, canSeeFinance, canManageUsers } from "../lib/constants";

export function IfCanWrite({ children, fallback = null }: { children: ReactNode; fallback?: ReactNode }) {
  const { user } = useAuth();
  return canWrite(user?.role) ? <>{children}</> : <>{fallback}</>;
}

export function IfCanSeeFinance({ children, fallback = null }: { children: ReactNode; fallback?: ReactNode }) {
  const { user } = useAuth();
  return canSeeFinance(user?.role) ? <>{children}</> : <>{fallback}</>;
}

export function RouteGate({
  allow,
  children,
}: {
  allow: (role: string | null | undefined) => boolean;
  children: ReactNode;
}) {
  const { user } = useAuth();
  if (!allow(user?.role)) {
    return (
      <div style={{ padding: 40, textAlign: "center", color: "var(--text-muted)" }}>
        <h2 style={{ fontSize: 20, marginBottom: 8, color: "var(--text)" }}>Access restricted</h2>
        <p style={{ fontSize: 14 }}>Your role does not have permission to view this page.</p>
      </div>
    );
  }
  return <>{children}</>;
}

export { canWrite, canSeeFinance, canManageUsers };
